import script from "./GuestOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestOrder.vue?vue&type=script&setup=true&lang=js"

import "./GuestOrder.vue?vue&type=style&index=0&id=f7685d78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7685d78"]])

export default __exports__